import { render, staticRenderFns } from "./DokumenRekomendasi.vue?vue&type=template&id=1635f124&scoped=true&"
import script from "./DokumenRekomendasi.vue?vue&type=script&lang=js&"
export * from "./DokumenRekomendasi.vue?vue&type=script&lang=js&"
import style0 from "./DokumenRekomendasi.vue?vue&type=style&index=0&id=1635f124&scoped=true&lang=css&"
import style1 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1635f124",
  null
  
)

export default component.exports